import {TabsReducer} from '../../../common/tabs/tabs.reducer';
import {IDS} from './requirements-assessment-action-id.constants';

export const requirementsAssessmentTabs = {
    [IDS.app_accreditation_scheme_requirements_assessment_evidence_groups]: Object.assign( TabsReducer(),
        { tabs: [
            {
                state: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_list,
                title: 'Requirement',
                visible: true,
                disabled: false,
                loading: false,
            },
            {
                state: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_details,
                title: 'Evidence Group',
                visible: true,
                disabled: true,
                loading: false
            },
            {
                state: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_doc_revision_request,
                title: 'Revision Request',
                visible: false,
                disabled: false,
                loading: false,
            },
            {
                state: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_improvement,
                title: 'Improvement Request',
                visible: false,
                disabled: false,
                loading: false,
            },
            {
                state: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_history,
                title: 'Review History',
                visible: true,
                disabled: true,
                loading: false
            },
        ]}
    ),
}
